// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"94":"Login","237":"StationScreen","380":"WindHome","684":"Admin","736":"ActualPower","779":"SolarHome"}[chunkId] || chunkId) + "." + {"94":"a79ae4cc","191":"cc5ea77d","237":"a9c09601","373":"6a2f40f2","380":"e9668d67","638":"e023d340","684":"03b4ab62","736":"80b7e0f7","779":"3839526b"}[chunkId] + ".js";
};